import { differenceInDays, format, subDays } from "date-fns";

/**
 * Dias desde a última compra, derivado AO VIVO de last_purchase_date.
 * Substitui o campo podre customer_portfolio.days_since_last_purchase
 * (foto congelada que só atualizava no sync por venda — F1 do §I.99).
 * null = sem compra registrada.
 */
export function daysSinceLastPurchase(
  lastPurchaseDate: string | null | undefined
): number | null {
  if (!lastPurchaseDate) return null;
  return differenceInDays(new Date(), new Date(lastPurchaseDate));
}

export type Temperature = "quente" | "morno" | "frio";

/**
 * Temperatura derivada na leitura. Thresholds vêm das configurações da empresa
 * (crm_risk_days/crm_lost_days via useChurnThresholds), nunca hardcoded.
 * F5 (unquadragesies): sem compra = SEM temperatura (null) — ausência de dado não se veste
 * de melhor caso (era 'quente', primo do COALESCE 100 do sentimento). O primitivo de banco
 * get_customer_temperature ainda carrega o traço velho — lavrado para higiene, não tocado.
 */
export function deriveTemperature(
  lastPurchaseDate: string | null | undefined,
  riskDays: number,
  lostDays: number
): Temperature | null {
  const days = daysSinceLastPurchase(lastPurchaseDate);
  if (days === null) return null;
  if (days <= riskDays) return "quente";
  if (days <= lostDays) return "morno";
  return "frio";
}

/**
 * Data de corte (yyyy-MM-dd) para filtros server-side sobre last_purchase_date.
 * Equivalência com o filtro antigo sobre o campo podre:
 *   dias ≤ N  ⇔  last_purchase_date ≥ cutoff(N)
 *   dias > N  ⇔  last_purchase_date < cutoff(N)
 */
export function purchaseDateCutoff(daysAgo: number): string {
  return format(subDays(new Date(), daysAgo), "yyyy-MM-dd");
}
